import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import backarrow from "../../../../asset/images/arrow-backicon.svg";
import Header from "../../../../Components/Header";
import SingleSignOnSideBar from "../../../../Components/SingleSignOnSideBar";
import Loader from "../../../../Components/Common/Loader";
import { Dealer_Mapping } from "../../../../Configuration/API_URL";
import { decryptData, noDataFound } from "../../../../CommonMethhods/CommonMethods";
import axiosInstance from "../../../../CommonMethhods/axiosInstance";
import CheckerSingleRequestDetails from "./CheckerSingleRequestDetails";
import CheckerBulkRequestDetails from "./CheckerBulkRequestDetails";

function CheckerRequestDetails() {
  const { batchId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  // Row handed over by the dashboard - kept only as an instant fallback so the
  // page still renders correctly on refresh / direct URL, where it is absent.
  const [summary, setSummary] = useState(location.state?.request || null);
  const [rowData, setRowData] = useState(null);
  const [loader, setLoader] = useState(true);

  const isBulk = String(batchId || "").toUpperCase().startsWith("BLK");

  const status = (
    summary?.status ||
    rowData?.status ||
    rowData?.requests?.[0]?.approvalStatus ||
    ""
  ).toString();

  const isPending = status.trim().toLowerCase() === "pending";

  // const goToDashboard = () => {
  //   navigate("/dealer-mapping", {
  //     state: { activeTab: isPending ? "pendingApp" : "dashboard" },
  //   });
  // };
  // The Pending Approvals tab is switched off, so Go Back and the return after
  // an approve / reject / send back both land on the dashboard.
  const goToDashboard = () => {
    navigate("/dealer-mapping", { state: { activeTab: "dashboard" } });
  };

  // Batch details - there is no dedicated checker detail-by-id route on the
  // backend (/my-applications/:batchId exists but is scoped to the caller's
  // own requests, so it 404s for a checker viewing someone else's batch).
  // The checker's history grid endpoint (checkerMyRequest, filtered down to
  // this one SR) is the only endpoint that actually returns this batch's
  // data for a checker, so it's used directly as rowData.
  const getRequestDetails = async () => {
    try {
      const queryParams = new URLSearchParams({
        format: "grid",
        status: "all",
        type: "all",
        fromDate: "",
        toDate: "",
        batchIdRef: batchId,
      });

      const response = await axiosInstance.get(
        `${Dealer_Mapping.checkerMyRequest}?${queryParams}`
      );
      const decrypted = JSON.parse(decryptData(response?.data));

      if (decrypted?.status === 0) {
        const match = (decrypted?.data || []).find(
          (item) => item?.batchId?.toUpperCase() === String(batchId).toUpperCase()
        );
        if (match) {
          setSummary(match);
          setRowData(match);
          return true;
        }
      }
    } catch (error) {
      console.log(error);
    }
    return false;
  };

  useEffect(() => {
    if (!batchId) {
      setLoader(false);
      return;
    }

    let isActive = true;

    (async () => {
      setLoader(true);

      const found = await getRequestDetails();

      if (isActive && !found && location.state?.request) {
        setRowData(location.state.request);
      }
      if (isActive) setLoader(false);
    })();

    return () => {
      isActive = false;
    };
  }, [batchId]);

  const renderContent = () => {
    if (loader) {
      return (
        <div className="loader-alignment">
          <Loader />
        </div>
      );
    }

    if (!batchId || !rowData) {
      return (
        <div className="step-content report-error-message">
          {noDataFound("Request details are not available")}
        </div>
      );
    }

    return isBulk ? (
      <CheckerBulkRequestDetails
        batchId={batchId}
        status={status}
        rowData={rowData}
        summary={summary}
        onActionDone={goToDashboard}
      />
    ) : (
      <CheckerSingleRequestDetails
        batchId={batchId}
        status={status}
        rowData={rowData}
        summary={summary}
        onActionDone={goToDashboard}
      />
    );
  };

  return (
    <div className="dealer-mapping-main">
      <Header portal={""} showUserId />
      <SingleSignOnSideBar />
      <main id="dealermap-main-content">
        <div className="tab-content card-box cl-mapping-tab">
          <div className="ckr-page new-upload">
            <button type="button" className="dlr-go-back" onClick={() => goToDashboard()}>
              <img src={backarrow} alt="back" />
              <span className="back-title">Go Back</span>
            </button>

            {renderContent()}
          </div>
        </div>
      </main>
    </div>
  );
}

export default CheckerRequestDetails;
